export default function PokerChipIcon({
  color = "currentColor",
  size = 24,
  title = "Poker chip icon",
  ...props
}) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      role="img"
      aria-label={title}
      fill={color}
    >
      <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM22,12a10,10,0,0,1-.186,1.9l-1.932-.58a7.442,7.442,0,0,0,0-2.64l1.932-.58A10,10,0,0,1,22,12Zm-.76-3.816-1.93.579A8.048,8.048,0,0,0,15.237,4.69l.579-1.93A10.058,10.058,0,0,1,21.24,8.184ZM12,18a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,18ZM13.9,2.186l-.58,1.932a7.442,7.442,0,0,0-2.64,0L10.1,2.186a9.8,9.8,0,0,1,3.8,0ZM8.184,2.76l.579,1.93A8.048,8.048,0,0,0,4.69,8.763L2.76,8.184A10.058,10.058,0,0,1,8.184,2.76ZM2,12a10,10,0,0,1,.186-1.9l1.932.58a7.442,7.442,0,0,0,0,2.64l-1.932.58A10,10,0,0,1,2,12Zm.76,3.816,1.93-.579A8.048,8.048,0,0,0,8.763,19.31l-.579,1.93A10.058,10.058,0,0,1,2.76,15.816Zm7.34,6,.58-1.932a7.442,7.442,0,0,0,2.64,0l.58,1.932a9.8,9.8,0,0,1-3.8,0Zm5.716-.575-.579-1.929a8.048,8.048,0,0,0,4.073-4.073l1.93.579A10.053,10.053,0,0,1,15.816,21.239ZM14.631,10.892a1.848,1.848,0,0,1,0,2.216l-1.893,2.523a.922.922,0,0,1-1.476,0L9.369,13.108a1.848,1.848,0,0,1,0-2.216l1.893-2.523a.922.922,0,0,1,1.476,0Z" />
    </svg>
  );
}
